import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://nkoggxueocchfosokhtk.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5rb2dneHVlb2NjaGZvc29raHRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxNDE0NDMsImV4cCI6MjA2NzcxNzQ0M30.LbUh8I3SMJSqDl9erAhBSTGpZxbvDKsonHjKxLmXbYg";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
